import arrowDoubleLeft from "@assets/images/arrow-double-left.svg";
import arrowDoubleRight from "@assets/images/arrow-double-right.svg";
import arrowLeft from "@assets/images/arrow-left-2.svg";
import arrowRight from "@assets/images/arrow-right.svg";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";

const useStyles = makeStyles(
  theme => ({
    iconButton: {
      "& > span:first-of-type": {
        transition: "none"
      },
      padding: "0.2rem 0.4rem",
      "&:hover": {
        color: theme.palette.grey[900]
      }
    },
    iconDoubleButton: {
      "& > span:first-of-type": {
        transition: "none"
      },
      padding: "0.2rem 0.4rem",
      "&:hover": {
        color: theme.palette.grey[900]
      },
      "& .MuiSvgIcon-root": {
        margin: "0 -5px"
      }
    },
    btnDisable: {
      background: `${theme.palette.background.default} !important`,
      "& path": {
        fill: theme.palette.grey[500]
      }
    }
  }),
  { name: "TablePaginationAction" }
);

export interface ITablePaginationActionProp {
  backIconButtonProps?: any;
  className?: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextIconButtonProps?: any;
  disabled?: boolean;
  isBackFistPage?: boolean;
  isNextLastPage?: boolean;
  onNextPage(event);
  onPreviousPage(event);
  onPreviousFirstPage(event);
  onNextLastPage(event);
}

export const TablePaginationAction: React.FC<ITablePaginationActionProp> = props => {
  const {
    backIconButtonProps,
    className,
    hasNextPage,
    hasPreviousPage,
    nextIconButtonProps,
    isBackFistPage,
    isNextLastPage,
    disabled = false,
    onNextPage,
    onPreviousPage,
    onPreviousFirstPage,
    onNextLastPage,
    ...rest
  } = props;
  const classes = useStyles(props);
  const isDisablePreviousPage = disabled || !hasPreviousPage;
  const isDisableNextPage = disabled || !hasNextPage;

  return (
    <div className={className} {...rest}>
      {isBackFistPage ? (
        <IconButton
          className={classNames(
            classes.iconDoubleButton,
            isDisablePreviousPage && classes.btnDisable
          )}
          onClick={onPreviousFirstPage}
          disabled={isDisablePreviousPage}
          id="button-pagination-back-first-page"
          data-testid="button-pagination-back-first-page"
          {...backIconButtonProps}
        >
          <SVG fontSize={"12"} src={arrowDoubleLeft} />
        </IconButton>
      ) : null}
      <IconButton
        className={classNames(
          classes.iconButton,
          isDisablePreviousPage && classes.btnDisable
        )}
        onClick={onPreviousPage}
        disabled={isDisablePreviousPage}
        id="button-pagination-back"
        data-testid="button-pagination-back"
        {...backIconButtonProps}
      >
        <SVG src={arrowLeft} />
      </IconButton>
      <IconButton
        className={classNames(
          classes.iconButton,
          isDisableNextPage && classes.btnDisable
        )}
        onClick={onNextPage}
        disabled={isDisableNextPage}
        id="button-pagination-next"
        data-testid="button-pagination-next"
        {...nextIconButtonProps}
      >
        <SVG src={arrowRight} />
      </IconButton>
      {isNextLastPage ? (
        <IconButton
          className={classNames(
            classes.iconDoubleButton,
            isDisableNextPage && classes.btnDisable
          )}
          onClick={onNextLastPage}
          disabled={isDisableNextPage}
          id="button-pagination-next-last-page"
          data-testid="button-pagination-next-last-page"
          {...nextIconButtonProps}
        >
          <SVG src={arrowDoubleRight} />
        </IconButton>
      ) : null}
    </div>
  );
};

export default React.memo(TablePaginationAction);
